"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _reactRedux = require("react-redux");
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
/**
 * Copyright 2016-present, Deloitte Digital.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
/**
 * React Redux DOM Factory
 */
var ReduxDomFactory = /*#__PURE__*/function () {
  function ReduxDomFactory() {
    var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck2.default)(this, ReduxDomFactory);
    /**
     * The redux store
     */
    this.store = store;
  }

  /**
   * Inject the module into the dom wrapped in a redux provider
   * @param {*} module - The component to inject
   * @param {object} props  - The component props
   * @param {node} target - The node to inject to
   */
  (0, _createClass2.default)(ReduxDomFactory, [{
    key: "inject",
    value: function inject(module) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var target = arguments.length > 2 ? arguments[2] : undefined;
      if (target) {
        _reactDom.default.render(_react.default.createElement(_reactRedux.Provider, {
          store: this.store
        }, _react.default.createElement(module, props)), target);
      }
    }

    /**
     * Dispose of any react instances for a node
     * @param {node} target - The node to tear down
     */
  }, {
    key: "dispose",
    value: function dispose(target) {
      if (target) {
        _reactDom.default.unmountComponentAtNode(target);
      }
    }
  }]);
  return ReduxDomFactory;
}();
exports.default = ReduxDomFactory;